import api from '@/utils/api';

/**
 * Update Category
 * @param {string} id Category id
 * @param {object} categoryData - The Category data
 * @returns {Promise}
 */
const updateCategoryApi = (id, categoryData) =>
  api.patch(`/category/${id}`, categoryData);

export default updateCategoryApi;
